import { UseQueryOptions } from '@tanstack/react-query';
import {
	GetAccountInfoRequestPath,
	GetBrandingThemesRequestPath,
	GetItemsRequestPath,
	GetTaxRatesRequestPath,
	XeroControllerPath,
	PrimeExpressionParserPayload,
	urlCombine,
	XeroAccountInfo,
	XeroBrandingThemeInfo,
	XeroItemInfo,
	XeroTaxRateInfo,
} from 'ihub/common';
import {
	getTenantID,
	microServiceAPI,
	standardPost,
	validateOkResponse,
} from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';

export class XeroHttpService {
	getAccountsQuery(
		payload: PrimeExpressionParserPayload
	): UseQueryOptions<XeroAccountInfo[], Error, XeroAccountInfo[]> {
		return {
			queryKey: [getTenantID(), XeroControllerPath, GetAccountInfoRequestPath, payload.flowID],
			queryFn: async (): Promise<XeroAccountInfo[]> => {
				const url = urlCombine(microServiceAPI, XeroControllerPath, GetAccountInfoRequestPath);
				const res = await standardPost(url, payload);
				await validateOkResponse(res, 'Get Xero account info', 'XeroAccountInfo');
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	getTaxRatesQuery(
		payload: PrimeExpressionParserPayload
	): UseQueryOptions<XeroTaxRateInfo[], Error, XeroTaxRateInfo[]> {
		return {
			queryKey: [getTenantID(), XeroControllerPath, GetTaxRatesRequestPath, payload.flowID],
			queryFn: async (): Promise<XeroTaxRateInfo[]> => {
				const url = urlCombine(microServiceAPI, XeroControllerPath, GetTaxRatesRequestPath);
				const res = await standardPost(url, payload);
				await validateOkResponse(res, 'Get Xero tax rates', 'XeroTaxRateInfo');
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	getBrandingThemesQuery(
		payload: PrimeExpressionParserPayload
	): UseQueryOptions<XeroBrandingThemeInfo[], Error, XeroBrandingThemeInfo[]> {
		return {
			queryKey: [getTenantID(), XeroControllerPath, GetBrandingThemesRequestPath, payload.flowID],
			queryFn: async (): Promise<XeroBrandingThemeInfo[]> => {
				const url = urlCombine(microServiceAPI, XeroControllerPath, GetBrandingThemesRequestPath);
				const res = await standardPost(url, payload);
				await validateOkResponse(res, 'Get Xero branding themes', 'XeroBrandingThemeInfo');
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	getItemsQuery(
		payload: PrimeExpressionParserPayload
	): UseQueryOptions<XeroItemInfo[], Error, XeroItemInfo[]> {
		return {
			queryKey: [getTenantID(), XeroControllerPath, GetItemsRequestPath, payload.flowID],
			queryFn: async (): Promise<XeroItemInfo[]> => {
				const url = urlCombine(microServiceAPI, XeroControllerPath, GetItemsRequestPath);
				const res = await standardPost(url, payload);
				await validateOkResponse(res, 'Get Xero items', 'XeroItemInfo');
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}
}
